<template>
  <div @click="$emit('click')" style="cursor: pointer; display: inline-block;">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 512 512"
    >
      <g
        :stroke="isDarkTheme ? headingTextColor : '#ffffff'"
        fill="none"
        stroke-width="25"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <!-- Outer circle -->
        <circle cx="256" cy="256" r="200" />

        <!-- "i" stem -->
        <line x1="256" y1="220" x2="256" y2="340" />

        <!-- "i" dot -->
        <circle cx="256" cy="150" r="20" fill="currentColor" />
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: "InfoIcon",
  computed: {
    isDarkTheme() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.isDarkTheme
      ) {
        return this.$store.state.sdkEvent.isDarkTheme;
      }
      return null;
    },
    headingTextColor() {
      if (
        this.$store.state.sdkEvent &&
        this.$store.state.sdkEvent.themeColors &&
        this.$store.state.sdkEvent.themeColors.headingTextColor
      ) {
        return this.$store.state.sdkEvent.themeColors.headingTextColor;
      }
      return null;
    }
  }
};
</script>

<style scoped>
/* div:hover {
  opacity: 0.7;
  transition: opacity 0.2s;
} */
</style>
